import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/search.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-27f6b504"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("input", {
      class: "input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
      placeholder: "Поиск.."
    }, null, 512), [
      [_vModelText, _ctx.search]
    ]),
    _createElementVNode("button", {
      class: "btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFilterChanged()))
    }, _hoisted_2)
  ], 64))
}